import Dialog from 'material-ui/Dialog/Dialog';
import DialogTitle from 'material-ui/Dialog/DialogTitle';
import DialogContent from 'material-ui/Dialog/DialogContent';
import DialogContentText from 'material-ui/Dialog/DialogContentText';
import DialogActions from 'material-ui/Dialog/DialogActions';

import AlertDialog from './AlertDialog';

export { DialogTitle, DialogContent, DialogContentText, DialogActions, AlertDialog };
export default Dialog;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Dialog/index.ts